// Plan detail page. The brand Plans card and the chat plan card link here.
// Reads GET /api/marketing/plans/:planId/detail. Production status and
// suggestions render inside the panel when their flags are on.

import { Link as RouterLink, useParams, useSearchParams } from 'react-router-dom';
import { Button, Text } from '@chakra-ui/react';
import { useBrand } from '../brand/BrandContext';
import { PlanDetailPanel } from '../components/marketingPlan/PlanDetailView';
import { planBrandMismatch } from '../marketingPlans/detail';
import { PageHeader } from '../shell/PageHeader';

const NOT_YOUR_BRAND = 'This plan was not found, or it is not your brand.';

export function PlanDetailPage() {
  const { planId } = useParams();
  const [search] = useSearchParams();
  const { activeBrand } = useBrand();
  const queryBrand = search.get('brandId');
  const activeId = activeBrand?.id ?? null;
  // A query brand is not authorized until the active brand has resolved and matches.
  // Null active is a mismatch, same as the performance page.
  const brandMismatch = planBrandMismatch(queryBrand, activeId);
  const brandId = brandMismatch ? null : (queryBrand || activeId);
  const revision = search.get('revision');

  return (
    <>
      <PageHeader
        eyebrow="Plan"
        title="Plan detail"
        description="Structure, forecast, production, and suggestions for this plan."
        secondaryAction={<Button as={RouterLink} to="/brand" variant="outline">Back to brand</Button>}
      />
      {!planId && <Muted>Select a plan to open its detail.</Muted>}
      {planId && brandMismatch && <Text fontSize="sm" data-testid="plan-detail-mismatch">{NOT_YOUR_BRAND}</Text>}
      {planId && !brandMismatch && !brandId && <Muted>Select a brand to open this plan.</Muted>}
      {planId && brandId && (
        <div data-testid="plan-detail">
          <PlanDetailPanel brandId={brandId} planId={planId} revision={revision} />
        </div>
      )}
    </>
  );
}

function Muted({ children }: { children: string }) {
  return <Text fontSize="sm" color="brand.muted">{children}</Text>;
}
